import { render, staticRenderFns } from "./footer-primary.component.vue?vue&type=template&id=535ec5c6&"
import script from "./footer-primary.component.vue?vue&type=script&lang=ts&"
export * from "./footer-primary.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports